import { Badge, Tooltip } from '@mantine/core';
import { ERROR_HELP, errorColor, statusColor } from '../theme/format';

export function StatusBadge({ status }: { status: string }) {
  return <Badge color={statusColor(status)}>{status}</Badge>;
}

/**
 * A taxonomy code with its plain-English meaning attached.
 *
 * The tooltip is the point. `UNREGISTERED` means nothing to someone opening this
 * for the first time, and the difference between "we already handled it" and
 * "you need to fix something" is exactly what an operator is trying to work out.
 */
export function ErrorCodeBadge({ code, detail }: { code?: string | null; detail?: string | null }) {
  if (!code) return null;
  const help = ERROR_HELP[code];
  const label = (
    <Badge color={errorColor(code)} style={{ cursor: help ? 'help' : undefined }}>
      {code}
    </Badge>
  );
  if (!help && !detail) return label;

  return (
    <Tooltip
      multiline
      w={340}
      withArrow
      label={
        <>
          {help}
          {detail ? ` — ${detail}` : ''}
        </>
      }
    >
      {label}
    </Tooltip>
  );
}
